import React from 'react';
import { ArrowLeft, Bell, RefreshCw, Clock, Video, Megaphone, Code, Database } from 'lucide-react';

const Historique = () => {
  const transactions = [
    {
      date: 'Jeudi 01 janvier 2025',
      items: [
        {
          icon: 'circles',
          title: 'Motion Design',
          description: 'Maîtrisez les outils de co...',
          amount: '+ 30.800 XOF',
          time: 'Du 01/01/2025 à 08h17',
          color: 'bg-red-200'
        }
      ]
    },
    {
      date: 'Mardi 05 février 2025',
      items: [
        {
          icon: 'video',
          title: 'Création de Vidéo',
          description: 'Apprenez à réaliser des v...',
          amount: '+ 35.500 XOF',
          time: 'Du 05/02/2025 à 21h35',
          color: 'bg-emerald-200'
        },
        {
          icon: 'megaphone',
          title: 'Marketing Digital',
          description: 'Formation sur les stratégi...',
          amount: '+ 17.300 XOF',
          time: 'Du 05/02/2025 à 21h35',
          color: 'bg-gray-900'
        }
      ]
    },
    {
      date: 'Lundi 24 décembre 2024',
      items: [
        {
          icon: 'code',
          title: 'Formation Node JS',
          description: 'Vous allez maitriser comm...',
          amount: '+ 89.500 XOF',
          time: 'Du 24/12/2024 à 18h01',
          color: 'bg-blue-600'
        },
        {
          icon: 'database',
          title: 'Intro à la Data Science',
          description: 'Découvrez les bases de la...',
          amount: '+ 22.500 XOF',
          time: 'Du 24/12/2024 à 10h50',
          color: 'bg-red-600'
        }
      ]
    }
  ];

  const getIcon = (iconName) => {
    switch (iconName) {
      case 'circles':
        return <div className="w-6 h-6 text-red-600">⭕</div>;
      case 'video':
        return <Video className="w-6 h-6 text-emerald-600" />;
      case 'megaphone':
        return <Megaphone className="w-6 h-6 text-white" />;
      case 'code':
        return <Code className="w-6 h-6 text-white" />;
      case 'database':
        return <Database className="w-6 h-6 text-white" />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-purple-50">
      {/* Header */}
      <header className="bg-white px-4 py-3 flex items-center justify-between border-b border-purple-100">
        <div className="flex items-center space-x-4">
          <button className="p-1 hover:bg-purple-50 rounded-full transition-colors">
            <ArrowLeft className="w-6 h-6 text-blue-600" />
          </button>
          <h1 className="text-blue-600 text-lg font-medium">Historique</h1>
        </div>
        <button className="p-1 hover:bg-purple-50 rounded-full transition-colors relative">
          <Bell className="w-6 h-6 text-gray-700" />
        </button>
      </header>

      {/* Balance Section */}
      <div className="px-4 py-8 text-center">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-gray-800 text-lg">Balance Disponible</h2>
          <button className="p-2 hover:bg-purple-100 rounded-full transition-colors">
            <RefreshCw className="w-5 h-5 text-gray-600" />
          </button>
        </div>
        <p className="text-5xl font-bold text-gray-700 tracking-tight">
          320.000 F CFA
        </p>
      </div>

      {/* Transactions List */}
      <div className="px-4 pb-8">
        {transactions.map((group, index) => (
          <div key={index} className="mb-8">
            <h3 className="text-lg font-medium text-gray-800 mb-4">
              {group.date}
            </h3>
            <div className="space-y-4">
              {group.items.map((item, itemIndex) => (
                <div key={itemIndex} className="bg-white rounded-2xl p-4 shadow-sm">
                  <div className="flex items-start justify-between">
                    <div className="flex space-x-3">
                      <div className={`p-3 rounded-xl ${item.color} flex items-center justify-center`}>
                        {getIcon(item.icon)}
                      </div>
                      <div>
                        <h4 className="font-medium text-gray-900">{item.title}</h4>
                        <p className="text-gray-500 text-sm">{item.description}</p>
                        <div className="flex items-center text-gray-400 text-sm mt-2">
                          <Clock className="w-4 h-4 mr-1" />
                          <span>{item.time}</span>
                        </div>
                      </div>
                    </div>
                    <span className="text-gray-900 font-medium">{item.amount}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Historique;